import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import ContactPage from "./components/ContactPage";
import MailingListForm from "./components/MailingListForm";
import ResourcesPage from "./components/ResourcesPage";
import Footer from "./layouts/Footer";
import Nav from "./layouts/Nav";
import ScrollToTop from "./utils/ScrollToTop";
import NotFound from "./components/NotFound";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsPage from "./components/TermsPage";
import CookiePolicyPage from "./components/CookiePolicyPage";
import CookieConsent from "./components/parts/CookieConsent";

class App extends Component {
  render() {
    return (
        <Router>
          <div>
            <Nav />
              <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/resources-form" element={<MailingListForm />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="*" element={<NotFound />} /> {/* Catch-all route */}
            </Routes>
            <CookieConsent />
            <Footer />
          </div>
        </Router>
    );
  }
}

export default App;
